import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';
import { CommonFunctions } from '../utils/common-functions';
import { Global } from '../utils/global';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  employeeCode: string;
  employeeNick: string;
  encabezadoOrigen: any;
  urlbasePivote = `${environment.apiPivote}`;
  // -----------------------------
  datosCliente: any = {}; // obtenidos de consulta cliente
  datosCodeudor: any = {}; // obtenidos de consulta cliente
  datosPrecalificacion: any = {}; // datos de la nueva precalificacion
  datosPrecalificacionCodeudor: any = {}; // datos de la nueva precalificacion
  productosCliente: any = {}; // productos internos y externos del cliente de sirc
  productosCodeudor: any = {}; // productos internos y externos del cliente de sirc
  precalificacionBase: any = {}; // precalificacion realizada previamente
  TotalCosolidacion = 0;
  datosPorductosClientes = []; // obtenido de pantalla consolidacion
  commonCredits = []; // créditos en común de deudor y codeudor
  ofertasComerciales;
  listReglaRechazo = [];
  listReglaRechazoCodeudor = [];
  reglaRechazo = 'V';
  bienestarSFM = 0;
  bienestarSF = 0;
  flowType = '';
  debtorScore = '';
  coDebtorScore = '';
  manualEntry = false;
  isLoadIndex = false;
  ofertaseleccionada;
  ofertamym;
  mixAndMachMontoAhorro = 0;
  banderSinofertas = false;
  productoDetalleSelected;
  consultaFlag = false
  permisos = {
    accesoportal: true,
    moduloDetalleEvaluacion: true,
    moduloNuevaEvaluacion: true,
    descargaDocumentos: true
  };
  formatterDecimal = new Intl.NumberFormat('es-GT', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'decimal',
  });
  headerspivote
  headerspivoteV2
  headersseguridad
  rolVerificacionFlag = false
  rolABFlag=false
  tipoPrecalificacion=''
  constructor(
    private http: HttpClient,
    private ngxRoleService: NgxRolesService,
    private ngxPermissionService: NgxPermissionsService,
  ) {
    const apppv2 = atob("MU9ERU1leHRuRjhad1JQaVBoN1pxZFZiRXMvUk0zT0pLM1Z3Ti9TbEtBbU5lMmFIWWMxYk5jWndNY3lZQU51Q1JYU0ZUSlZpK0FZNHhkdzlBREZHelA5KzFZT1ovMTFOTnM4UExvcTd2WFhLTUkrZzFYaEZMM1dNVDU4YkJIVGFaZTlOemxpL1RIc3FUeS9ZalRvR3MzRDRBSWp6TnBQZ2ZDZVRuL05EaStNPQ==");
    const pvheadersv1 = `{"${atob("dXNlci1iYW5jYS1idA==")}":"${atob("UDNyUzBuNEwxejRDMTBuLjBiQEI0blRyNGI=")}","${atob("cGFzc3dvcmQtYmFuY2EtYnQ=")}":"${atob("TW95WWhtYjJheTJIOHVFcUNkbUJ0d29YajJrNGFENnhWd2pucUlPaUg5aXZSVUxyZVFrUXAzOVZoalVBemtHMA==")}"}`
    const headerssg = `{"${atob("dXNlci1iYW5jYS1idA==")}":"${atob("UDNyUzBuNEwxejRDMTBuLjBiQEI0blRyNGI=")}","${atob("cGFzc3dvcmQtYmFuY2EtYnQ=")}":"${atob("elVCQE5rT0lKZzhX")}"}`

    this.headerspivote = new HttpHeaders(
      JSON.parse(pvheadersv1)
    );
    this.headerspivoteV2 = new HttpHeaders(
      {
        app: `"${apppv2}"`
      });
    this.headersseguridad = new HttpHeaders(
      JSON.parse(headerssg)
    );
    this.loadSessionData();
  }
  /**
   * Carga en el servicio los datos que dependen de la sesión (usuario y banderas de rol).
   * Debe invocarse al autenticarse, ya que el servicio es singleton y se construye al
   * arrancar la aplicación, cuando todavía no existe una sesión en el localStorage.
   */
  loadSessionData() {
    this.employeeCode = localStorage.getItem('codigoEmpleado');
    this.employeeNick = localStorage.getItem('nickUser');
    this.encabezadoOrigen = {
      sitemaBantrab: 'ACIERTO',
      canalOrigen: 'WEB',
      idUsuario: this.employeeCode ?? '54919',
      usuario: this.employeeNick
        ? this.employeeNick.toUpperCase() : 'ANGEL_CASTELLANOS',
      direccionIP: '181.174.107.170'
    };
    const permissionsStorage = JSON.parse(!!localStorage.getItem('permissions')?localStorage.getItem('permissions'):"[]")
    this.rolVerificacionFlag = permissionsStorage.find(i => i.nombre_permiso == 'EVALUACION TIPO VERIFICACION') ? permissionsStorage.find(i => i.nombre_permiso == 'EVALUACION TIPO VERIFICACION').activo : false
    this.rolABFlag = permissionsStorage.find(i => i.nombre_permiso == 'EVALUACION TIPO AGENTE BANCARIO') ? permissionsStorage.find(i => i.nombre_permiso == 'EVALUACION TIPO AGENTE BANCARIO').activo : false
  }
  validateTokenAB(tokenab) {
    return new Promise<any>((resolve, reject) => {
      let item={
        "Llave": environment.agentestoken,
        "Token":tokenab
      }
      this.http.post<any>(this.urlbasePivote +'/api/v1/CanalesDigitales/validarToken',
        item,{ headers: this.headerspivoteV2 }).subscribe(data => {
          if (data.codigo == 1 && data.Respuesta!=null && data.Respuesta.Exitoso) {
            this.employeeCode= data.Respuesta.codigoempleado
            localStorage.setItem('codigoEmpleado', data.Respuesta.codigoempleado);
            localStorage.setItem('nickUser', data.Respuesta.nickUser);
            localStorage.setItem('nombre', data.Respuesta.nombre);
            localStorage.setItem('datacn', JSON.stringify({
              codigocn: data.Respuesta.codigocn,
              nombrecn: 'AGENTES BANCARIOS'
            }));
            resolve(data.Respuesta)
          } else {
           reject() 
          }
        }, error => {
          reject(error);
        });
    });
  }
  solicitudOTP(telefono,dpi=this.datosCliente.cliente.dpi,producto: string) {
    return new Promise<any>((resolve, reject) => {
      let item={
        "telefono": telefono,
        "dpi": dpi,
        "producto": producto
      }
      this.http.post<any>(this.urlbasePivote +'/api/v1/CanalesDigitales/solicitaTerminosyCondiciones',
        item,{ headers: this.headerspivoteV2 }).subscribe(data => {
          if (data.codigo == 1 && data.Respuesta.codigo=='0') {
            resolve(data.Respuesta.mensaje)
          } else {
           reject() 
          }
        }, error => {
          reject();
        });
    });
  }
  validarOTP(otp,cel,dpi) {
    return new Promise<any>((resolve, reject) => {
      let item={
        "otp": otp,
        "telefono": cel,
        "dpi": dpi
      }
      this.http.post<any>(this.urlbasePivote +'/api/v1/CanalesDigitales/confirmarTerminosyCondiciones',
        item,{ headers: this.headerspivoteV2 }).subscribe(data => {
          if (data.codigo == 1 && data.Respuesta.codigo=='0') {
            resolve(data.Respuesta.mensaje)
          } else {
           reject(data.Respuesta.mensaje) 
          }
        }, error => {
          reject(error);
        });
    });
  }
  sendEmailDetalleAB(resultado,datapreca,email:string=this.datosCliente.cliente.email.toLowerCase()){
    return new Promise<any>((resolve, reject) => {
      let message = `
      <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Document</title>
        <style>
            @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;700&display=swap');
            p {
                font-family: 'Rubik', sans-serif;
            }
            h1 {
                font-family: 'Rubik', sans-serif;
                font-size: 32px;
                font-weight: 700;
                font-stretch: normal;
            }
            td{
                text-align: left;
                margin-left: 25px;
            }
        </style>
    </head>
    <body>
        <div>
            <div style="padding: 50px; margin: 50px auto 50px auto; border-radius: 8px; border: solid 1px #d3d2d4;  width: 400px;">
            <div  style="text-align: right;">
            <img style="margin-left:auto !important ;" src="https://firebasestorage.googleapis.com/v0/b/bantrab-app.appspot.com/o/logobtwhite.jpg?alt=media&token=1702c65f-b484-437d-ab15-c3cc26720d98" alt="" height="80">
            </div>  
              <table>
                    <tbody>
                       <tr>
                        <th>AGENTE BANCARIO</th>
                       </tr> 
                        <tr>
                            <td>No. de precalificación:</td>
                            <td>${datapreca.noPrecalificacion}</td>
                        </tr>
                        <tr>
                            <td>Usuario:</td>
                            <td>${datapreca.usuarioAbf}</td>
                        </tr>
                        <tr>
                            <td>Fecha:</td>
                            <td>${datapreca.fechaRegistro}</td>
                        </tr>
                        <tr>
                            <td>Nombre:</td>
                            <td>${datapreca.nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td>Resultado:</td>
                            <td style="color:${resultado=='PREAPROBADO'?'#00aeb3':resultado=='RECHAZADO'?'#dd2460':'#ffcb00'}">${resultado}</td>
                        </tr>
                    </tbody>
                </table>
                <p style=" font-size: 14px; font-weight: normal; font-stretch: normal; font-style: normal; line-height: 1.5; letter-spacing: normal; text-align: justify; color: #000;"><strong>El Banco de los Trabajadores</strong> es responsable por las operaciones realizadas y por los servicios prestados, por cuenta de este, por el agente bancario.</p>
            </div>
        </div>
    </body>
    </html>
      `
      let item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          emailDestino: email,
          asunto: 'Resultado precalificación',
          mensaje: message,
        },
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/enviarEmail',
        item,{ headers: this.headerspivoteV2 }).subscribe(data => {
          if (data.codigo == 1 && data.Respuesta.codigoError=='0') {
            resolve(data.Respuesta.mensaje)
          } else {
           reject(data.Respuesta.mensaje) 
          }
        }, error => {
          reject(error);
        });
    });
  }
  sendSmsAB(datapreca,cel,resultado){
    return new Promise<any>((resolve, reject) => {
      const tipoProducto = datapreca.tipoProducto === '004' || datapreca.tipoProducto === 'tarjeta_credito' ? 'tarjeta de crédito' : 'préstamo';
      
      let item={
        "telefono": cel,
        "mensaje": `Gracias por utilizar Mi Agente Bantrab, su operación de precalificación de ${tipoProducto} con número: ${datapreca.noPrecalificacion} tiene un estado: ${resultado}, puede acercarse a su centro de negocio Bantrab más cercano para continuar con su proceso.`
      }
      this.http.post<any>(this.urlbasePivote +'/api/v1/CanalesDigitales/envioSms',
        item,{ headers: this.headerspivoteV2 }).subscribe(data => {
          if (data.codigo == 1 && data.Respuesta.codigo=='0') {
            resolve(data.Respuesta.mensaje)
          } else {
           reject(data.Respuesta.mensaje) 
          }
        }, error => {
          reject(error);
        });
    });
  }
  consultaPrecalificacionPorAbf() {
    let primerdiames = moment().startOf('month').format('DD/MM/YYYY');
    let ultimodiames = moment().endOf('month').format('DD/MM/YYYY');
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultaPrecalificacionPorAbf',
        { "encabezadoOrigen": this.encabezadoOrigen, "solicitud": { "antiguedadAbf": this.employeeCode, "fechaInicio": primerdiames, "fechaFin": ultimodiames } }, { headers:this.headerspivoteV2 }).subscribe(datos => {
          datos = datos.Respuesta
          resolve(datos)
        }, error => {
          reject(error)
        })
    })
  }
  loginUser(user, password) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(
        this.urlbasePivote + '/api/ConsultasBt/consultaCredenciales',
        { usuario: user, contrasenia: password },
        { headers: this.headerspivote }).subscribe(result => {
          const data = result.Respuesta;
          if (data == null) {
            reject('error');
          }
          localStorage.setItem('codigoEmpleado', data[0].codigoEmpleado);
          localStorage.setItem('departamento', data[0].departamento);
          localStorage.setItem('nickUser', data[0].nickUser);
          localStorage.setItem('nombre', data[0].nombre);
          if (data[0].error === false) {
            localStorage.setItem('currentUser', 'false');
            resolve(data);
          } else {
            reject(data[0].error);
          }
        }, error => {
          reject(error);
        });
    });
  }
  ofertaPorMes(
    beginDate = moment(new Date()).format('DD/MM/YYYY'),
    endDate = moment(new Date()).format('DD/MM/YYYY'),
    filterColor = 'VERDE',
    codigocn = JSON.parse(window.localStorage.getItem('datacn')).codigocn
  ) {
    return new Promise<any>((resolve, reject) => {
      const item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          fechaInicio: beginDate,
          fechaFin: endDate,
          estadoColor: filterColor,
          centroNegocio: codigocn
          // "fechaInicio": "09/09/2021",
          // "fechaFin": "30/09/2021",
        }
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultaPrecalificacionPorRango', item, { headers: this.headerspivoteV2 }).subscribe(data => {
        const precas = [];

        if (data.Respuesta.rango.length > 0) {
          data.Respuesta.rango.forEach(item => {
            if (item.estadoColorPrecalificacion !== 'SIN_COLOR') {
              precas.push(item);
            }
          });
        }

        resolve(precas);
      }, error => {
        reject(error);
      });
    });
  }
  getPrecalificacion(numeroPreca) {
    return new Promise<any>((resolve, reject) => {
      const item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          noPrecalificacion: numeroPreca,
        }
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultaPrecalificacionBitacora', item, 
      { headers: this.headerspivoteV2 }).subscribe(datos => {
        resolve(datos.Respuesta);
      }, error => {
        reject(error);
      });
    });
  }
  getPrecalificacionesPorCliente(dpi, fechaInicio, fechaFin) {
    return new Promise<any>((resolve, reject) => {
      const item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          dpi: dpi,
          fechaInicio: fechaInicio,
          fechaFin: fechaFin
        }
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultaPrecalificacionPorProspecto', item, { headers: this.headerspivoteV2 }).subscribe(datos => {
        if (datos.codigo == 1) {
          let precalificaciones = []
          datos.Respuesta.prospecto.forEach(element => {
            let aux = {
              origen: element.origen,
              estadoColorPrecalificacion: element.estadoColorPrecalificacion,
              noPrecalificacion: element.noPrecalificacion,
              participante: [
                {
                  dpi: element.dpi,
                  nombreCompleto:
                    element.participante[0].primerNombre +
                    " " +
                    element.participante[0].primerApellido,
                  tipoParticipante: "DEUDOR",
                },
              ],
            }
            precalificaciones.push(aux)
          });
          resolve(precalificaciones);
        } else {
          reject()
        }
      }, error => {
        reject(error);
      });
    });
  }
  getInfoCliente(dpi) {
    return new Promise<any>((resolve, reject) => {
      const item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          dpi,
        }
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultaCliente', item, { headers: this.headerspivoteV2 }).subscribe(datos => {
        resolve(datos.Respuesta);
      }, error => {
        reject(error);
      });
    });
  }
  consultaCN(codigo) {
    return new Promise<any>((resolve, reject) => {
      const item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          antiguedadAbf: codigo,
        }
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultarCentroNegocioPorABF', item, { headers: this.headerspivoteV2 }).subscribe(datos => {
        resolve(datos.Respuesta);
      }, error => {
        reject(error);
      });
    });
  }
  ConsultaProducoCliente(datacliente) {
    return new Promise<any>((resolve, reject) => {
      const item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          documento: datacliente.dpi,
          nit: !datacliente.nit || datacliente.nit === ''
            ? ''
            : CommonFunctions.getNitWithUnderscore(datacliente.nit),
          primerNombre: this.getCleanedString(datacliente.primerNombre).replace(new RegExp(/\W/g), ''),
          primerApellido: this.getCleanedString(datacliente.primerApellido).replace(new RegExp(/\W/g), '')
        }
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultaProductoCliente', item, { headers: this.headerspivoteV2 }).subscribe(datos => {
        if (datos.codigo == 1) {
          if (datos.Respuesta.error.codigoError == '0') {
            if (this.flowType === 'DEBTOR') {
              this.productosCliente = datos.Respuesta;
            } else {
              this.productosCodeudor = datos.Respuesta;
            }
            resolve(datos.Respuesta);
          } else {
            reject(datos.Respuesta)
          } 
        } else {
          reject(datos.mensaje)
        }
      }, error => {
        reject(error);
      });
    });
  }
  getCuentasCliente() {
    return new Promise<any>((resolve, reject) => {
      const body = {
        codigocliente: this.datosCliente.cliente.codigoClienteBantrab,
      };

      this.http
        .post<any>(
          `${environment.apiPivote}/api/v1/Autogestion/Cliente/Productos`,
          body,
          {
            headers: new HttpHeaders()
              .set('Content-Type', 'application/json')
              .set('User-banca-bt', environment.autogestionUser)
              .set('Password-banca-bt', environment.autogestionPassword),
          }
        )
        .subscribe(
          (datos) => {
            if (datos.codigo == 1 && datos.Respuesta.errors.length == 0) {
              resolve(datos.Respuesta);
            } else {
              reject(datos.Respuesta);
            }
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  integracionBancaBT(noevaluacion, tipopreca) {
    return new Promise<any>((resolve, reject) => {
      let urlIntegracion = tipopreca == '004' ? '/api/ConsultasBt/integracionBancaTC' : '/api/ConsultasBt/integracionBancaBT'
      this.http.post<any>(this.urlbasePivote + urlIntegracion,
        { encabezadoOrigen: this.encabezadoOrigen, solicitud: { numeroPrecalificacion: noevaluacion, usuarioBanca: 'ACIERTOWEB' } }, { headers: this.headerspivoteV2 }).subscribe(datos => {
          resolve(datos.Respuesta);
        }, error => {
          reject(error);
        });
    });
  }
  getRolesYpermisos(id) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(this.urlbasePivote + '/api/SeguridadAcierto/Usuarios/' + id, { headers: this.headersseguridad }).subscribe(datos => {
        if (datos.Respuesta.resultado) {
          this.setRolesYpermisos(datos.Respuesta);
          resolve(datos.Respuesta);
        } else {
          reject();
        }
      }, error => {
        reject(error);
      });
    });
  }
  setRolesYpermisos(data) {
    if (data.respuesta.modulos.find(i => i.id_modulo == 11) != null && data.respuesta.modulos.find(i => i.id_modulo == 11).activo == '1') {
      this.permisos.moduloDetalleEvaluacion = true;
      const aux = data.respuesta.modulos.find(i => i.id_modulo == 11);
      if (aux.permisos.find(i => i.nombre == 'descarga de documentos') != null) {
        if (aux.permisos.find(i => i.nombre == 'descarga de documentos').activo == 1) {
          this.permisos.descargaDocumentos = true;
        } else {
          this.permisos.descargaDocumentos = false;
        }
      }
    } else {
      this.permisos.moduloDetalleEvaluacion = false;
    }
    if (data.respuesta.modulos.find(i => i.id_modulo == 12) != null && data.respuesta.modulos.find(i => i.id_modulo == 12).activo == '1') {
      this.permisos.moduloNuevaEvaluacion = true;
    } else {
      this.permisos.moduloNuevaEvaluacion = false;
    }
  }
  loginRolesyPermisos() {
    return new Promise<any>((resolve, reject) => {
      const item = {
        user: 'ACI3rt$',
        password: 'zUB@NkOIJg8W'
      };
      this.http.post<any>(this.urlbasePivote + '/api/SeguridadAcierto/', item).subscribe(datos => {
        resolve(datos.respuesta);
      }, error => {
        reject(error);
      });
    });
  }
  consultaPatrono(datapatrono) {
    return new Promise<any>((resolve, reject) => {
      const item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          numeroPatrono: datapatrono.numeropatrono,
          descripcionPatrono: datapatrono.descripcionpatrono
        }
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultaPatrono', item, { headers: this.headerspivoteV2 }).subscribe(datos => {
        resolve(datos.Respuesta);
      }, error => {
        reject(error);
      });
    });
  }
  logOut() {
    localStorage.clear();
    this.ngxPermissionService.flushPermissions();
    this.ngxRoleService.flushRolesAndPermissions();
    this.loadSessionData();
  }
  consultaBDprecalificada(dpi) {
    return new Promise<any>((resolve, reject) => {
      this.http.get<any>(this.urlbasePivote + '/api/Bienestar/ServicioAcierto/' + dpi, { headers: this.headerspivote }).subscribe(datos => {
        resolve(datos.Respuesta);
      }, error => {
        reject(error);
      });
    });
  }
  getProductosCliente() {
    return this.productosCliente;
  }
  getcurrentdate() {
    return moment().locale('es').format('DD/MM/YYYY');
  }
  getDateFormat(date) {
    const fecha = moment(date, 'DD/MM/YYYY').locale('es').format('DD/MM/YYYY');
    return fecha.toString();
  }
  getDateFormatSlashToHyphen(date) {
    const fecha = moment(date, 'DD/MM/YYYY').locale('es').format('YYYY-MM-DD');
    return fecha.toString();
  }
  getDateFormatHyphenToSlash(date) {
    const fecha = moment(date, 'YYYY-MM-DD').locale('es').format('DD/MM/YYYY');
    return fecha.toString();
  }
  
  dateIsBefore(date1, date2) {
    const aux1 = moment(date1, 'DD/MM/YYYY').locale('es').format('YYYY-MM-DD');
    const aux2 = moment(date2, 'DD/MM/YYYY').locale('es').format('YYYY-MM-DD');
    const result = moment(aux1).isBefore(aux2);
    return result;
  }
  setMontoyPlazo(item) {
    this.datosPrecalificacion.plazo = item.plazo;
    this.datosPrecalificacion.monto = item.monto.toString();
  }
  setIngresosyDedudcciones(item) {
    if (this.flowType === 'DEBTOR') {
      this.datosPrecalificacion.ingresosydeducciones = item;
    } else {
      this.datosPrecalificacionCodeudor.ingresosydeducciones = item;
    }
  }

  getOfertasComerciales(datos) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/solicitarOfertaComercial', datos, { headers: this.headerspivoteV2 }).subscribe(datos => {
        if(datos.Respuesta!=null){
          resolve(datos.Respuesta)
        }else{
          reject('504')
        }
      }, error => {
        reject(error);
      });
    });
  }
  solicitarOfertaComercialTC(data) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/solicitarOfertaComercialTC',
        data, { headers: this.headerspivoteV2}).subscribe(datos => {
          datos = datos.Respuesta
          resolve(datos)
        }, error => {
          reject(error)
        })
    })
  }

  seleccionarOfertaComercial(data) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/seleccionarOfertaComercial',
        data, { headers: this.headerspivoteV2 }).subscribe(datos => {
          resolve(datos.Respuesta);
        }, error => {
          reject(error);
        });
    });
  }
  getEdadCliente() {
    const fechaIngresada = moment(this.datosCliente.cliente.fechaNacimiento, 'DD/MM/YYYY').locale('es');
    const fechaactual = moment().locale('es');
    return fechaactual.diff(fechaIngresada, 'years');
  }
  getCleanedString(cadena: string) {
    const specialChars = '!@#$^&%*()+=-[]\/{}|:<>?,.\'\'"·';

    // Los eliminamos todos
    for (let i = 0; i < specialChars.length; i++) {
      cadena = cadena.replace(new RegExp('\\' + specialChars[i], 'gi'), '');
    }
    cadena = cadena.toLowerCase();
    // cadena = cadena.replace(new RegExp(/\s/g),"");
    cadena = cadena.replace(new RegExp(/[àáâãäå]/g), 'a');
    cadena = cadena.replace(new RegExp(/æ/g), 'ae');
    cadena = cadena.replace(new RegExp(/ç/g), 'c');
    cadena = cadena.replace(new RegExp(/[èéêë]/g), 'e');
    cadena = cadena.replace(new RegExp(/[ìíîï]/g), 'i');
    cadena = cadena.replace(new RegExp(/ñ/g), 'n');
    cadena = cadena.replace(new RegExp(/[òóôõö]/g), 'o');
    cadena = cadena.replace(new RegExp(/œ/g), 'oe');
    cadena = cadena.replace(new RegExp(/[ùúûü]/g), 'u');
    cadena = cadena.replace(new RegExp(/[ýÿ]/g), 'y');
    // cadena = cadena.replace(new RegExp(/\W/g),"");
    return cadena.toUpperCase();
  }
  getCleanedStringblank(cadena: string) {
    const specialChars = '!@#$^&%*()+=-[]\/{}|:<>?,.\'\'"';

    // Los eliminamos todos
    for (let i = 0; i < specialChars.length; i++) {
      cadena = cadena.replace(new RegExp('\\' + specialChars[i], 'gi'), '');
    }
    cadena = cadena.toLowerCase();
    cadena = cadena.replace(/ /g, '_');
    cadena = cadena.replace(new RegExp(/[àáâãäå]/g), 'a');
    cadena = cadena.replace(new RegExp(/æ/g), 'ae');
    cadena = cadena.replace(new RegExp(/ç/g), 'c');
    cadena = cadena.replace(new RegExp(/[èéêë]/g), 'e');
    cadena = cadena.replace(new RegExp(/[ìíîï]/g), 'i');
    cadena = cadena.replace(new RegExp(/ñ/g), 'n');
    cadena = cadena.replace(new RegExp(/[òóôõö]/g), 'o');
    cadena = cadena.replace(new RegExp(/œ/g), 'oe');
    cadena = cadena.replace(new RegExp(/[ùúûü]/g), 'u');
    cadena = cadena.replace(new RegExp(/[ýÿ]/g), 'y');
    return cadena.toUpperCase();
  }
  getvalorDecimales(Valor: string) {
    if (Valor) {
      Valor = Valor.replace(',', '');
      let monto;
      if (Valor != '') {
        monto = this.toFixedTrunc(parseFloat(Valor), 2);
      } else {
        monto = '0.00';
      }
      return monto;
    } else {
      return '0.00';
    }
  }
  toFixed(x) {
    if (Math.abs(x) < 1.0) {
      const e = parseInt(x.toString().split('e-')[1]);
      if (e) {
        x *= Math.pow(10, e - 1);
        x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
      }
    } else {
      let e = parseInt(x.toString().split('+')[1]);
      if (e > 20) {
        e -= 20;
        x /= Math.pow(10, e);
        x += (new Array(e + 1)).join('0');
      }
    }
    return x;
  }
  toFixedTrunc(x, n) {
    x = this.toFixed(x);

    // From here on the code is the same than the original answer
    const v = (typeof x === 'string' ? x : x.toString()).split('.');
    if (n <= 0) { return v[0]; }
    let f = v[1] || '';
    if (f.length > n) { return `${v[0]}.${f.substr(0, n)}`; }
    while (f.length < n) { f += '0'; }
    return `${v[0]}.${f}`;
  }

  setListaPoliticasRechazadas() {
    const nombreOferta = 'Solicitud';
    this.ofertasComerciales.decisionOfertaComercial = this.ofertasComerciales.decisionOfertaComercial.filter(function (element, index, arr) {
      let result = false;
      if (element.nombreOferta.includes(nombreOferta)) {
        result = true;
      }
      if (element.reglaTipo.includes("Persona")) {
        result = true
      }
      return result;
    });
    for (let i = 0; i < this.ofertasComerciales.decisionOfertaComercial.length; i++) {
      if (this.ofertasComerciales.decisionOfertaComercial[i].nombreOferta == 'Solicitud' && this.ofertasComerciales.decisionOfertaComercial[i].reglaDecision == "RECHAZAR") {
        if (this.ofertasComerciales.decisionOfertaComercial[i].reglaParticipante == 'Deudor') {
          this.listReglaRechazo.push(this.ofertasComerciales.decisionOfertaComercial[i]);
        } else {
          this.listReglaRechazoCodeudor.push(this.ofertasComerciales.decisionOfertaComercial[i]);
        }
      }
    }
  }
  guardarCreditoRojo() {
    return new Promise<any>((resolve, reject) => {

      const ruta = this.ofertasComerciales.ofertaComercial[this.ofertasComerciales.ofertaComercial.length - 1];
      const data = {
        encabezadoOrigen: this.encabezadoOrigen,
        noPrecalificacion: this.ofertasComerciales.numeroPrecalificacion,
        ofertaComercialSeleccionada: ruta.idOferta
      };
      this.seleccionarOfertaComercial(data).then(datos => {
        resolve(datos);
      }).catch(error => {
        reject(error);
      });
    });
  }
  guardarCredito() {
    return new Promise<any>((resolve, reject) => {
      const ruta = this.ofertasComerciales.ofertaComercial[this.ofertaseleccionada];
      const datos = {
        encabezadoOrigen: this.encabezadoOrigen,
        noPrecalificacion: this.ofertasComerciales.numeroPrecalificacion,
        ofertaComercialSeleccionada: ruta.idOferta
      };
      this.seleccionarOfertaComercial(datos).then(datos => {
        resolve(datos);
      }).catch(error => reject('errorguardado'));
    });
  }
  // service modulo roles
  creasionRoles(datos) {
    return new Promise<any>((resolve, reject) => {
      this.http.post<any>(this.urlbasePivote + '/api/SeguridadAcierto/Roles', datos, { headers: this.headersseguridad }).subscribe(datos => {
        resolve(datos.Respuesta);
      }, error => {
        reject(error);
      });
    });
  }
  consultaClienteSAT(NitInput) {
    return new Promise<any>((resolve, reject) => {
      const headers = this.headerspivoteV2
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultaClienteSat',
        { encabezadoOrigen: this.encabezadoOrigen, solicitud: { nit: NitInput } }, { headers }).subscribe(datos => {
          datos = datos.Respuesta;
          resolve(datos);
        }, error => {
          reject(error);
        });
    });
  }

  consultaClienteSATNombre(data: any) {
    return new Promise<any>((resolve, reject) => {
      const headers = new HttpHeaders({
        'user-banca-bt': 'P3rS0n4L1z4C10n.0b@B4nTr4b',
        'password-banca-bt': 'MoyYhmb2ay2H8uEqCdmBtwoXj2k4aD6xVwjnqIOiH9ivRULreQkQp39VhjUAzkG0'
      });
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultaClienteSATxNombre',
        {
          encabezadoOrigen: this.encabezadoOrigen,
          encabezado: this.encabezadoOrigen,
          solicitud: data
        }, {
        headers
      }).subscribe(datos => {
        resolve(datos);
      }, error => {
        reject(error);
      });
    });
  }

  validateCustomerAcceptanceCriteria(isNewClient) {
    const date = moment().locale('es').format('DD/MM/YYYY');
    const hour = moment().locale('es').format('HH:mm');
    const dataSalary = this.getSalary();

    const httpOptions = {
      headers: this.headerspivoteV2,
    };

    const data = {
      encabezadoOrigen: {
        origen: 'ACIERTOWEB',
      },
      encabezado: {
        tipoProceso: '003',
        codigoSegmentoProducto: this.flowType === 'DEBTOR'
          ? this.datosPrecalificacion.segmento : this.datosPrecalificacionCodeudor.segmento,
        existeCodeudor: 'N',
        rutaFiltro: isNewClient ? 'rutaDosFiltro' : 'rutaUnoFiltro',
      },
      informacionGeneral: {
        origen: 'ACIERTOWEB',
        codigoAbf: localStorage.getItem('codigoEmpleado'),
        usuarioAbf: localStorage.getItem('nickUser').toUpperCase(),
        codigoCentroNegocio: JSON.parse(window.localStorage.getItem('datacn')).codigocn,
        ipMACAddress: '192.162.01.01',
        sistemaOperativo: 'TESTAPP',
        navegador: 'TESTAPP',
        nombreDispositivo: 'TESTAPP',
        fecha: date,
        hora: hour,
        latitud: '14.6083',
        longitud: '-90.5155'
      },
      participante: this.flowType === 'DEBTOR' ? [
        {
          dpi: this.datosCliente.cliente.dpi,
          tipoClienteBanca: this.datosCliente.cliente.tipoClasificacionCliente,
          tipoParticipante: 'DEUDOR',
          codigoSegmentoProducto: this.datosPrecalificacion.segmento,
          datosIndice: {
            patrono: this.datosPrecalificacion.patronoSelected,
            empleadoGobierno: dataSalary.customerempleadoGobierno,
          }
        }
      ] : [
        {
          dpi: this.datosCodeudor.cliente.dpi,
          tipoClienteBanca: this.datosCodeudor.cliente.tipoClasificacionCliente,
          tipoParticipante: 'DEUDOR',
          codigoSegmentoProducto: this.datosPrecalificacionCodeudor.segmento,
          datosIndice: {
            patrono: this.datosPrecalificacionCodeudor.patronoSelected,
            empleadoGobierno: dataSalary.customerempleadoGobierno,
          }
        }
      ],
    };

    return this.http.post(`${this.urlbasePivote}/api/ConsultasBt/validarCriterioAceptacionCliente`, data, httpOptions);
  }

  getSalary() {
    const clientData = this.flowType === 'DEBTOR'
      ? this.datosCliente : this.datosCodeudor;
    const precalificationData = this.flowType === 'DEBTOR'
      ? this.datosPrecalificacion : this.datosPrecalificacionCodeudor;

    const position = clientData.datosIndice.isMoreChiefs
      && clientData.datosIndice.position
      ? clientData.datosIndice.position : 0;
    let salarioLiquidoGeneral;
    let customerempleadoGobierno = null;
    if (precalificationData.segmento === 'E') {
      if (clientData.cliente.tipoClasificacionCliente === 'CN'
        && clientData.cliente.codigoClienteBantrab === '0') {
        customerempleadoGobierno = {
          identificadorEmpleado: precalificationData.datosPatrono.codigoEmpleado,
          nombre: clientData.cliente.nombreCompleto,
          cedula: clientData.cliente.dpi,
          salarioLiquido: precalificationData.ingresosydeducciones.salarioLiquidoBT,
          salarioNominal: precalificationData.ingresosydeducciones.salarioBase,
          fechaIngreso: this.getDateFormatSlashToHyphen(precalificationData.datosPatrono.fechaingreso),
          reglonPresupuestario: precalificationData.datosPatrono.reglon,
          valorDescuentoJudicial: this.getvalorDecimales(precalificationData.ingresosydeducciones.judiciales ?? '0.00'),
          valorDescuentoCuotaBantrab: precalificationData.ingresosydeducciones.cuotaBancoIndice
        };
        clientData.cliente.ultimoTotalIngresosRerportado = precalificationData.ingresosydeducciones.salarioBase;
        const dirreccion = {
          correlativoDireccion: '1',
          departamento: clientData.cliente.departamento,
          direccionRegistrada: clientData.cliente.direccionRegistrada,
          esDireccionPrincipal: 'S',
          municipio: clientData.cliente.municipio,
          tipoDireccionRegistrada: '1'
        };
        precalificationData.direccion = dirreccion;
        salarioLiquidoGeneral = this.getvalorDecimales(clientData.cliente.ultimoTotalIngresosRerportado);
      } else {
        if (clientData.datosIndice.clienteDatosIndice.length > 0
          && precalificationData.datosPatrono.codigoPatrono !== '46001') {
          if (position > 0) {
            customerempleadoGobierno = {
              identificadorEmpleado: clientData.datosIndice.clienteDatosIndice[position].identificadorEmpleado,
              nombre: clientData.datosIndice.clienteDatosIndice[position].nombre,
              cedula: clientData.datosIndice.clienteDatosIndice[position].cedula,
              salarioLiquido: clientData.datosIndice.clienteDatosIndice[position].salarioLiquido,
              salarioNominal: clientData.datosIndice.clienteDatosIndice[position].salarioNominal,
              fechaIngreso: this.getDateFormatSlashToHyphen(clientData.datosIndice.clienteDatosIndice[position].fechaIngreso),
              reglonPresupuestario: clientData.datosIndice.clienteDatosIndice[position].reglonPresupuestario,
              valorDescuentoJudicial: this.getvalorDecimales(clientData.datosIndice.clienteDatosIndice[position].valorDescuentoJudicial),
              valorDescuentoCuotaBantrab: clientData.datosIndice.clienteDatosIndice[position].valorDescuentoCuotaBantrab
            };
          } else {
            customerempleadoGobierno = {
              identificadorEmpleado: precalificationData.datosPatrono.codigoEmpleado,
              nombre: clientData.cliente.nombreCompleto,
              cedula: clientData.cliente.dpi,
              salarioLiquido: precalificationData.ingresosydeducciones.salarioLiquidoBT,
              salarioNominal: precalificationData.ingresosydeducciones.salarioBase,
              fechaIngreso: this.getDateFormatSlashToHyphen(precalificationData.datosPatrono.fechaingreso),
              reglonPresupuestario: precalificationData.datosPatrono.reglon,
              valorDescuentoJudicial: this.getvalorDecimales(precalificationData.ingresosydeducciones.judiciales ?? '0.00'),
              valorDescuentoCuotaBantrab: precalificationData.ingresosydeducciones.cuotaBancoIndice
            };
          }
        } else {
          customerempleadoGobierno = {
            identificadorEmpleado: precalificationData.datosPatrono.codigoEmpleado =
              precalificationData.datosPatrono.codigoEmpleado = !null
                ? precalificationData.datosPatrono.codigoEmpleado : '0',
            nombre: this.getCleanedString(clientData.cliente.nombreCompleto),
            cedula: clientData.cliente.dpi,
            salarioLiquido: clientData.datosIndice.clienteDatosIndice.length > 0
              ? clientData.datosIndice.clienteDatosIndice[position].salarioLiquido
              : this.getvalorDecimales(clientData.cliente.ultimoTotalIngresosRerportado),
            salarioNominal: clientData.datosIndice.clienteDatosIndice.length > 0
              ? clientData.datosIndice.clienteDatosIndice[position].salarioNominal
              : this.getvalorDecimales(clientData.cliente.ultimoTotalIngresosRerportado),
            fechaIngreso: precalificationData.datosPatrono.fechaingreso,
            reglonPresupuestario: precalificationData.datosPatrono.reglon,
            valorDescuentoJudicial: clientData.datosIndice.clienteDatosIndice.length > 0
              ? this.getvalorDecimales(clientData.datosIndice.clienteDatosIndice[position].valorDescuentoJudicial)
              : '0.00',
            valorDescuentoCuotaBantrab: clientData.datosIndice.clienteDatosIndice.length > 0
              ? this.getvalorDecimales(clientData.datosIndice.clienteDatosIndice[position].valorDescuentoCuotaBantrab) : '0.00',
          };
        }
        salarioLiquidoGeneral = clientData.datosIndice.clienteDatosIndice.length > 0
          ? this.getvalorDecimales(clientData.datosIndice.clienteDatosIndice[position].salarioLiquido)
          : this.getvalorDecimales(clientData.cliente.ultimoTotalIngresosRerportado);
      }
    }

    return {
      salarioLiquidoGeneral,
      customerempleadoGobierno,
    };
  }

  rejectCoDebtorFlow() {
    this.listReglaRechazoCodeudor = [];
    this.datosCodeudor = {};
    this.datosPrecalificacionCodeudor = {};
    this.commonCredits = [];
    this.flowType = 'DEBTOR';
    return new Promise<any>((resolve, reject) => {
      this.datosCliente.needCoDebtor = false;
      resolve('R');
    });
  }

  getCoDebtor() {
    if (this.datosCodeudor.cliente.tipoClasificacionCliente === 'CN'
      && this.datosCodeudor.cliente.existeClienteActivoBanca === 'N') {
      const dirreccion = {
        correlativoDireccion: '1',
        departamento: this.datosCodeudor.cliente.departamento,
        direccionRegistrada: this.datosCodeudor.cliente.direccionRegistrada,
        esDireccionPrincipal: 'S',
        municipio: this.datosCodeudor.cliente.municipio,
        tipoDireccionRegistrada: '1'
      };
      this.datosPrecalificacionCodeudor.direccion = dirreccion;
    }
    const salary = this.getSalary();
    const coDebtor = {
      codigoClienteBantrab: this.datosCodeudor.cliente.codigoClienteBantrab,
      esClienteBantrab: this.datosCodeudor.cliente.existeClienteActivoBanca,
      tipoParticipante: 'CODEUDOR',
      tipoClienteBanca: this.datosCodeudor.cliente.tipoClasificacionCliente,
      codigoSegmentoProducto: this.datosPrecalificacionCodeudor.segmento,
      codigoSegmentoRiesgoPagoVoluntario: this.datosPrecalificacionCodeudor.codigoSegmentoRiesgoPagoVoluntario,
      datosGenerales: {
        certificacionSirc: this.productosCodeudor.rutaBusqueda.certificacionSirc,
        dpi: this.datosCodeudor.cliente.dpi,
        nit: this.datosCodeudor.cliente.nit,
        primerNombre: this.getCleanedString(this.datosCodeudor.cliente.primerNombre),
        segundoNombre: this.datosCodeudor.cliente.segundoNombre !== ''
          ? this.getCleanedString(this.datosCodeudor.cliente.segundoNombre) : ' ',
        tercerNombre: ' ',
        primerApellido: this.getCleanedString(this.datosCodeudor.cliente.primerApellido),
        segundoApellido: this.datosCodeudor.cliente.segundoApellido !== ''
          ? this.getCleanedString(this.datosCodeudor.cliente.segundoApellido) : ' ',
        apellidoCasada: this.datosCodeudor.cliente.casadaApellido !== ''
          ? this.getCleanedString(this.datosCodeudor.cliente.casadaApellido) : ' ',
        estadoCivil: this.datosCodeudor.cliente.estadoCivil,
        tipoVivienda: this.datosCodeudor.cliente.tipoVivienda ?? '1',
        fechaNacimiento: this.datosCodeudor.cliente.fechaNacimiento,
        correoElectronico: this.datosCodeudor.cliente.email === ''
          ? 'example@example.com' : this.datosCodeudor.cliente.email === 'NO TIENE'
            ? 'example@example.com' : this.datosCodeudor.cliente.email === 'NO POSEE'
              ? 'example@example.com' : this.datosCodeudor.cliente.email ===
                'CLIENTE NO POSEE CORREO ELECTRÓNICO' ? 'example@example.com'
                : this.datosCodeudor.cliente.email.toLowerCase(),
        otroEmpleo: this.datosPrecalificacionCodeudor.datosPatrono.empleoanterior,
        fechaInicioEmpleoAnterior: this.datosPrecalificacionCodeudor.datosPatrono.fechainicioempleoanterior === ''
          ? '01/01/1900' : this.datosPrecalificacionCodeudor.datosPatrono.fechainicioempleoanterior,
        fechaFinEmpleoAnterior: this.datosPrecalificacionCodeudor.datosPatrono.fechafinempleoanterior === ''
          ? '01/01/1900' : this.datosPrecalificacionCodeudor.datosPatrono.fechafinempleoanterior,
        fechaInicioEmpleoActual: this.datosPrecalificacionCodeudor.datosPatrono.fechaingreso,
        departamento:this.datosPrecalificacionCodeudor.direccion.departamento==null?'GUATEMALA': this.getCleanedStringblank(this.datosPrecalificacionCodeudor.direccion.departamento),
        municipio:this.datosPrecalificacionCodeudor.direccion.municipio==null?'GUATEMALA': this.getCleanedStringblank(this.datosPrecalificacionCodeudor.direccion.municipio),
        direccion:this.datosPrecalificacionCodeudor.direccion.direccionRegistrada==null?'CIUDAD': this.getCleanedString(this.datosPrecalificacionCodeudor.direccion.direccionRegistrada),
        telefonoMovil: this.datosPrecalificacionCodeudor.celular != null
          ? this.datosPrecalificacionCodeudor.celular : '42000000',
        telefonoCasa: this.datosPrecalificacionCodeudor.telefono != null
          ? this.datosPrecalificacionCodeudor.telefono : '24250000',
        genero: this.datosCodeudor.cliente.genero,
        appSalarioBase: this.getvalorDecimales(this.datosPrecalificacionCodeudor.ingresosydeducciones.salarioBase),
        appBonificaciones: this.getvalorDecimales(this.datosPrecalificacionCodeudor.ingresosydeducciones.bonificaciones),
        appComisiones: this.getvalorDecimales(this.datosPrecalificacionCodeudor.ingresosydeducciones.comisiones),
        appOtrosIngresos: this.getvalorDecimales(this.datosPrecalificacionCodeudor.ingresosydeducciones.otrosIngresos),
        appSalarioLiquido: this.datosPrecalificacionCodeudor.segmento === 'E'
          ? salary.salarioLiquidoGeneral : this.getvalorDecimales(this.datosPrecalificacionCodeudor.ingresosydeducciones.salarioBase),
        appIgss: this.getvalorDecimales(this.datosPrecalificacionCodeudor.ingresosydeducciones.igss),
        appIsr: this.getvalorDecimales(this.datosPrecalificacionCodeudor.ingresosydeducciones.isr),
        appDescuentosJudiciales: this.getvalorDecimales(this.datosPrecalificacionCodeudor.ingresosydeducciones.judiciales),
        appOtrasDeducciones: this.getvalorDecimales(this.datosPrecalificacionCodeudor.ingresosydeducciones.otrasDeducciones)
      },
      datosIndice: {
        patrono: this.datosPrecalificacionCodeudor.patronoSelected,
        empleadoGobierno: salary.customerempleadoGobierno,
      }
    };

    return coDebtor;
  }

  setDebtorScore() {
    this.debtorScore = this.ofertasComerciales.ofertaComercial
      && this.ofertasComerciales.ofertaComercial.length > 0
      ? this.ofertasComerciales.ofertaComercial[0].scoreDeudorSeleccionado : 'N/D';
    this.coDebtorScore = this.ofertasComerciales.ofertaComercial
      && this.ofertasComerciales.ofertaComercial.length > 0
      ? this.ofertasComerciales.ofertaComercial[0].scoreCodeudorSeleccionado : 'N/D';
  }

  createIniciativa(participantes) {
    return new Promise<any>((resolve, reject) => {
      const item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          participantes: participantes,
        }
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/insertarIniciativas', item, { headers: this.headerspivoteV2 }).subscribe(datos => {
        if (datos.codigo == 1 && datos.Respuesta.error.codigoError == null) {
          resolve(datos.Respuesta);
        } else {
          reject(datos)
        }
      }, error => {
        reject(error);
      });
    });
  }
  updateIniciativa(participantes) {
    return new Promise<any>((resolve, reject) => {
      const item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          participantes: participantes,
        }
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/modificarIniciativas', item, { headers: this.headerspivoteV2 }).subscribe(datos => {
        if (datos.codigo == 1) {
          resolve(datos.Respuesta);
        } else {
          reject(datos)
        }
      }, error => {
        reject(error);
      });
    });
  }
  downladReport(fechainicio, fechafin, estado) {
    return new Promise<any>((resolve, reject) => {
      const item = {
        encabezadoOrigen: this.encabezadoOrigen,
        solicitud: {
          fechaInicio: fechainicio,//dd/mm/yyyy
          fechaFin: fechafin,//dd/mm/yyyy
          estado: estado
        }
      };
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/consultarIniciativas', item, { headers: this.headerspivoteV2 }).subscribe(datos => {
        if (datos.codigo == 1) {
          resolve(datos.Respuesta);
        } else {
          reject(datos)
        }
      }, error => {
        reject(error);
      });
    });
  }
  changeColorPreca(productos, numeroPrecalificacion, politica, estadoActual, estadoNuevo, descripcion) {
    return new Promise<any>((resolve, reject) => {
      let item = {
        "encabezadoOrigen": this.encabezadoOrigen,
        "Autorizaciones": {
          "canalOrigen": "ACIERTO_WEB",
          "noPrecalificacion": numeroPrecalificacion,
          "tipoProceso": "001",
          "estadoColorPrecalificacion": estadoNuevo,
          "estadoColorPrecalificacionOrigen": estadoActual,
          "Fecha": this.getcurrentdate(),
          "usuario": this.employeeNick.toUpperCase(),
          "idUsuario": this.employeeCode,
          "descripcion": descripcion,
          "politica": politica,
          "activosCanceladosContraReserva": productos
        }
      }
      this.http.post<any>(this.urlbasePivote + '/api/ConsultasBt/enviarCCR', item, { headers: this.headerspivoteV2 }).subscribe(datos => {
        if (datos.codigo == 1) {
          resolve(datos.Respuesta);
        } else {
          reject(datos)
        }
      }, error => {
        reject(error);
      });
    });
  }
  solicitarOferta() {
    return new Promise<any>((resolve, reject) => {
      try {
        const fecha = moment().locale('es').format('DD/MM/YYYY');
        const hora = moment().locale('es').format('HH:mm');;
        /// consolidacion
        const datosConsolidacion = {
          consolidacionSirc: [],
          consolidacionCreditoBT: [],
          consolidacionTarjetaBT: []
        };
        let consolida = '';
        const position = this.datosCliente.datosIndice.isMoreChiefs
          && this.datosCliente.datosIndice.position
          ? this.datosCliente.datosIndice.position : 0;

        this.datosPorductosClientes.forEach(item => {
          if(item.descTipoActivo=="Tarjeta de Credito"&&item.codEntidad=="BANCO DE LOS TRABAJADORES"&&item.consolida){
            datosConsolidacion.consolidacionTarjetaBT.push(item.noTarjeta)
          }else if(item.descTipoActivo=="Prestamos"&&item.codEntidad=="BANCO DE LOS TRABAJADORES"&&item.consolida){
            datosConsolidacion.consolidacionCreditoBT.push(item.noCredito)
          } else {
            if (item.consolida) {
              datosConsolidacion.consolidacionSirc.push({
                codTipoActivo:item.codTipoActivo,
                nomEntidad:item.nomEntidad,
                fecconce:item.fecconce,
                capitalOrig:item.capitalOrig,
                saldo: item.saldo
              }) 
            }
          }
        });
        let customerempleadoGobierno = null;
        let salarioLiquidoGeneral;
        if (this.datosPrecalificacion.segmento === 'E') {
          // if (this.datosCliente.datosIndice.clienteDatosIndice.length > 0 && this.datosPrecalificacion.datosPatrono.codigoPatrono != '46001') {
          if (this.datosCliente.cliente.tipoClasificacionCliente === 'CN'
            && this.datosCliente.cliente.existeClienteActivoBanca === 'N') {
            customerempleadoGobierno = {
              identificadorEmpleado: this.datosPrecalificacion.datosPatrono.codigoEmpleado,
              nombre: this.datosCliente.cliente.nombreCompleto,
              cedula: this.datosCliente.cliente.dpi,
              salarioLiquido: this.datosPrecalificacion.ingresosydeducciones.salarioLiquidoBT,
              salarioNominal: this.datosPrecalificacion.ingresosydeducciones.salarioBase,
              fechaIngreso: this.getDateFormatSlashToHyphen(this.datosPrecalificacion.datosPatrono.fechaingreso),
              reglonPresupuestario: this.datosPrecalificacion.datosPatrono.reglon,
              valorDescuentoJudicial: this.getvalorDecimales(this.datosPrecalificacion.ingresosydeducciones.judiciales),
              valorDescuentoCuotaBantrab: this.datosPrecalificacion.ingresosydeducciones.cuotaBancoIndice
            };
            this.datosCliente.cliente.ultimoTotalIngresosRerportado = this.datosPrecalificacion.ingresosydeducciones.salarioBase;
            const dirreccion = {
              correlativoDireccion: '1',
              departamento: this.datosCliente.cliente.departamento,
              direccionRegistrada: this.datosCliente.cliente.direccionRegistrada,
              esDireccionPrincipal: 'S',
              municipio: this.datosCliente.cliente.municipio,
              tipoDireccionRegistrada: '1'
            };
            this.datosPrecalificacion.direccion = dirreccion;
            salarioLiquidoGeneral = this.datosCliente.datosIndice.clienteDatosIndice.length > 0
              ? this.getvalorDecimales(this.datosCliente.datosIndice.clienteDatosIndice[position].salarioLiquido)
              : this.getvalorDecimales(this.datosCliente.cliente.ultimoTotalIngresosRerportado);
          } else {
            if (this.datosCliente.datosIndice.clienteDatosIndice.length > 0 && this.datosPrecalificacion.datosPatrono.codigoPatrono != '46001' && this.manualEntry == false) {
              customerempleadoGobierno = {
                identificadorEmpleado: this.datosCliente.datosIndice.clienteDatosIndice[position].identificadorEmpleado,
                nombre: this.datosCliente.datosIndice.clienteDatosIndice[position].nombre,
                cedula: this.datosCliente.datosIndice.clienteDatosIndice[position].cedula,
                salarioLiquido: this.datosCliente.datosIndice.clienteDatosIndice[position].salarioLiquido,
                salarioNominal: this.datosCliente.datosIndice.clienteDatosIndice[position].salarioNominal,
                fechaIngreso: this.getDateFormatSlashToHyphen(this.datosCliente.datosIndice.clienteDatosIndice[position].fechaIngreso),
                reglonPresupuestario: this.datosCliente.datosIndice.clienteDatosIndice[position].reglonPresupuestario,
                valorDescuentoJudicial: this.getvalorDecimales(this.datosCliente.datosIndice.clienteDatosIndice[position].valorDescuentoJudicial),
                valorDescuentoCuotaBantrab: this.datosCliente.datosIndice.clienteDatosIndice[position].valorDescuentoCuotaBantrab
              };
            } else {
              customerempleadoGobierno = {
                identificadorEmpleado: this.datosPrecalificacion.datosPatrono.codigoEmpleado = this.datosPrecalificacion.datosPatrono.codigoEmpleado = !null ? this.datosPrecalificacion.datosPatrono.codigoEmpleado : '0',
                nombre: this.getCleanedString(this.datosCliente.cliente.nombreCompleto),
                cedula: this.datosCliente.cliente.dpi,
                salarioLiquido: this.datosCliente.datosIndice.clienteDatosIndice.length > 0 ? this.datosCliente.datosIndice.clienteDatosIndice[position].salarioLiquido : this.getvalorDecimales(this.datosCliente.cliente.ultimoTotalIngresosRerportado),
                salarioNominal: this.datosCliente.datosIndice.clienteDatosIndice.length > 0 ? this.datosCliente.datosIndice.clienteDatosIndice[position].salarioNominal : this.getvalorDecimales(this.datosCliente.cliente.ultimoTotalIngresosRerportado),
                fechaIngreso: this.datosPrecalificacion.datosPatrono.fechaingreso,
                reglonPresupuestario: this.datosPrecalificacion.datosPatrono.reglon,
                valorDescuentoJudicial: this.datosCliente.datosIndice.clienteDatosIndice.length > 0 ? this.getvalorDecimales(this.datosCliente.datosIndice.clienteDatosIndice[position].valorDescuentoJudicial) : '0.00',
                valorDescuentoCuotaBantrab: this.datosCliente.datosIndice.clienteDatosIndice.length > 0 ? this.getvalorDecimales(this.datosCliente.datosIndice.clienteDatosIndice[position].valorDescuentoCuotaBantrab) : '0.00',
              };
            }
            salarioLiquidoGeneral = this.datosCliente.datosIndice.clienteDatosIndice.length > 0
              ? this.getvalorDecimales(this.datosCliente.datosIndice.clienteDatosIndice[position].salarioLiquido)
              : this.getvalorDecimales(this.datosCliente.cliente.ultimoTotalIngresosRerportado);
          }

        } else {
          if (this.datosCliente.cliente.tipoClasificacionCliente === 'CN'
            && this.datosCliente.cliente.existeClienteActivoBanca === 'N') {
            const dirreccion = {
              correlativoDireccion: '1',
              departamento: this.datosCliente.cliente.departamento,
              direccionRegistrada: this.datosCliente.cliente.direccionRegistrada,
              esDireccionPrincipal: 'S',
              municipio: this.datosCliente.cliente.municipio,
              tipoDireccionRegistrada: '1'
            };
            this.datosPrecalificacion.direccion = dirreccion;
          }
          customerempleadoGobierno = {
            identificadorEmpleado: '',
            nombre: '',
            cedula: '',
            salarioLiquido: '',
            salarioNominal: '',
            fechaIngreso: '',
            reglonPresupuestario: '',
            valorDescuentoJudicial: '',
            valorDescuentoCuotaBantrab: '0'
          };
        }
        const datos = {
          encabezadoOrigen: {
            origen: 'ACIERTOWEB',
          },
          encabezado: this.tipoPrecalificacion=='credito_fiduciario'?{
            tipoProceso: '001',
            montoSolicitado: this.datosPrecalificacion.monto,
            montoSolicitadoCashOut: this.getvalorDecimales(this.datosPrecalificacion.montoSolicitudCashOut.toString()),
            plazo: this.datosPrecalificacion.plazo,
            codigoSegmentoProducto: this.datosPrecalificacion.segmento,
            existeCodeudor: this.flowType === 'DEBTOR' ? 'N' : 'S',
            mixAndMachFlgAplica: 'S',
            mixAndMachMontoAhorro: this.getvalorDecimales(this.mixAndMachMontoAhorro.toString()),
          }:{
            tipoProceso: '004',
            montoSolicitado: '0',
            montoSolicitadoCashOut: '0.00',
            plazo: '0',
            codigoSegmentoProducto:this.datosPrecalificacion.segmento,
            existeCodeudor:  'N',
            mixAndMachFlgAplica: 'N',
            mixAndMachMontoAhorro: '0.00',
          },
          informacionGeneral: {
            origen: this.rolABFlag?'AGENTESBANCARIOS':'ACIERTOWEB',
            codigoAbf: localStorage.getItem('codigoEmpleado'),
            usuarioAbf: localStorage.getItem('nickUser').toUpperCase(),
            codigoCentroNegocio: JSON.parse(window.localStorage.getItem('datacn')).codigocn,
            ipMACAddress: '192.162.01.01',
            sistemaOperativo: 'TESTAPP',
            navegador: 'TESTAPP',
            nombreDispositivo: 'TESTAPP',
            fecha,
            hora,
            latitud: '14.6083',
            longitud: '-90.5155'
          },
          participante: [
            {
              codigoClienteBantrab: this.datosCliente.cliente.codigoClienteBantrab,
              esClienteBantrab: this.datosCliente.cliente.existeClienteActivoBanca,
              tipoParticipante: 'DEUDOR',
              tipoClienteBanca: this.datosCliente.cliente.tipoClasificacionCliente,
              codigoSegmentoProducto: this.datosPrecalificacion.segmento,
              codigoSegmentoRiesgoPagoVoluntario:this.datosPrecalificacion.segmento=='PV'? this.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario:' ',
              datosGenerales: {
                certificacionSirc: this.productosCliente.rutaBusqueda.certificacionSirc,
                dpi: this.datosCliente.cliente.dpi,
                nit: this.datosCliente.cliente.nit,
                primerNombre: this.getCleanedString(this.datosCliente.cliente.primerNombre),
                segundoNombre: this.datosCliente.cliente.segundoNombre != '' ? this.getCleanedString(this.datosCliente.cliente.segundoNombre) : ' ',
                tercerNombre: ' ',
                primerApellido: this.getCleanedString(this.datosCliente.cliente.primerApellido),
                segundoApellido: this.datosCliente.cliente.segundoApellido != '' ? this.getCleanedString(this.datosCliente.cliente.segundoApellido) : ' ',
                apellidoCasada: this.datosCliente.cliente.casadaApellido != '' ? this.getCleanedString(this.datosCliente.cliente.casadaApellido) : ' ',
                estadoCivil: this.datosCliente.cliente.estadoCivil,
                tipoVivienda: this.datosCliente.cliente.tipoVivienda ?? '1',
                fechaNacimiento: this.datosCliente.cliente.fechaNacimiento,
                correoElectronico: this.datosCliente.cliente.email == '' ? 'example@example.com' : this.datosCliente.cliente.email == 'NO TIENE' ? 'example@example.com' : this.datosCliente.cliente.email == 'NO POSEE' ? 'example@example.com' : this.datosCliente.cliente.email == 'CLIENTE NO POSEE CORREO ELECTRÓNICO' ? 'example@example.com' : this.datosCliente.cliente.email.toLowerCase(),
                otroEmpleo: this.datosPrecalificacion.datosPatrono.empleoanterior,
                fechaInicioEmpleoAnterior: this.datosPrecalificacion.datosPatrono.fechainicioempleoanterior == '' ? '01/01/1900' : this.datosPrecalificacion.datosPatrono.fechainicioempleoanterior,
                fechaFinEmpleoAnterior: this.datosPrecalificacion.datosPatrono.fechafinempleoanterior == '' ? '01/01/1900' : this.datosPrecalificacion.datosPatrono.fechafinempleoanterior,
                fechaInicioEmpleoActual: this.datosPrecalificacion.datosPatrono.fechaingreso,
                departamento:this.datosPrecalificacion.direccion.departamento==null?'GUATEMALA': this.getCleanedStringblank(this.datosPrecalificacion.direccion.departamento),
                municipio:this.datosPrecalificacion.direccion.municipio==null?'GUATEMALA': this.getCleanedStringblank(this.datosPrecalificacion.direccion.municipio),
                direccion:this.datosPrecalificacion.direccion.direccionRegistrada==null?'CIUDAD': this.getCleanedString(this.datosPrecalificacion.direccion.direccionRegistrada),
                telefonoMovil: this.datosPrecalificacion.celular != null ? this.datosPrecalificacion.celular : '42000000',
                telefonoCasa: this.datosPrecalificacion.telefono != null ? this.datosPrecalificacion.telefono : '24250000',
                genero: this.datosCliente.cliente.genero,
                appSalarioBase: this.getvalorDecimales(this.datosPrecalificacion.ingresosydeducciones.salarioBase),
                appBonificaciones: this.getvalorDecimales(this.datosPrecalificacion.ingresosydeducciones.bonificaciones),
                appComisiones: this.getvalorDecimales(this.datosPrecalificacion.ingresosydeducciones.comisiones),
                appOtrosIngresos: this.getvalorDecimales(this.datosPrecalificacion.ingresosydeducciones.otrosIngresos),
                appSalarioLiquido: this.datosPrecalificacion.segmento === 'E'
                  ? salarioLiquidoGeneral
                  : this.getvalorDecimales(this.datosPrecalificacion.ingresosydeducciones.salarioBase),
                appIgss: this.getvalorDecimales(this.datosPrecalificacion.ingresosydeducciones.igss),
                appIsr: this.getvalorDecimales(this.datosPrecalificacion.ingresosydeducciones.isr),
                appDescuentosJudiciales: this.getvalorDecimales(this.datosPrecalificacion.ingresosydeducciones.judiciales),
                appOtrasDeducciones: this.getvalorDecimales(this.datosPrecalificacion.ingresosydeducciones.otrasDeducciones)
              },
              datosIndice: {
                patrono: this.datosPrecalificacion.patronoSelected,
                empleadoGobierno: customerempleadoGobierno
              }
            }
          ],
          consolidacionDeudas: datosConsolidacion
        }; // termina json datos solicitud

        if (this.flowType === 'CODEBTOR') {
          const coDebtor = this.getCoDebtor();
          datos.participante.push(coDebtor);
        }
        // se solicitan ofertas
        try {
          if(this.tipoPrecalificacion=='credito_fiduciario'){
            this.getOfertasComerciales(datos).then(data => {
              if (!data) {
                reject('504');
              }
              this.ofertasComerciales = data;
              this.reglaRechazo = 'V';
              if (this.ofertasComerciales.ofertasComerciales == null
                || this.ofertasComerciales.ofertasComerciales.length === 0) {
                reject(data.error)
              } else {
                if (this.ofertasComerciales.error.codigoError === '025'
                  || this.ofertasComerciales.error.codigoError === '004'
                  || this.ofertasComerciales.error.codigoError === '021'
                  || this.ofertasComerciales.error.codigoError === '017') {
                  reject(this.ofertasComerciales.error.codigoError);
                } else {
                  this.listReglaRechazo = [];
                  this.listReglaRechazoCodeudor = [];
                  this.ofertasComerciales.ofertaComercial = this.ofertasComerciales.ofertasComerciales.filter(item => item.color=='VERDE'||item.color=='AMARILLO'||item.tipo=="Solicitud")
                  if (this.ofertasComerciales.solicitaCodeudor == 'S') {
                    this.reglaRechazo = 'R'
                    this.listReglaRechazo = this.ofertasComerciales.reglasRechazoPersona
                    this.datosCliente.needCoDebtor = true;
                    localStorage.setItem("codeudor", "si");
                    resolve('A');
                  } else if (this.ofertasComerciales.aplicaCCR == 'S'&&this.ofertasComerciales.ofertaComercial.length>1) {
                    this.reglaRechazo = 'A'
                    if (this.ofertasComerciales.reglasRechazoPersona.length > 1) {
                      localStorage.setItem("codeudor", "si");
                      this.listReglaRechazo.push(this.ofertasComerciales.reglasRechazoPersona.find(item => item.reglaParticipante == "Deudor"))
                      this.listReglaRechazoCodeudor.push(this.ofertasComerciales.reglasRechazoPersona.find(item => item.reglaParticipante == "Codeudor"))
                    } else {
                      if (this.ofertasComerciales.reglasRechazoPersona[0].reglaParticipante == "Deudor") {
                        this.listReglaRechazo.push(this.ofertasComerciales.reglasRechazoPersona[0])
                      } else {
                        localStorage.setItem("codeudor", "si");
                        this.listReglaRechazoCodeudor.push(this.ofertasComerciales.reglasRechazoPersona[0])
                      }
                    }
                    resolve('A');
                  }else if(this.ofertasComerciales.ofertaComercial.length==1 && this.datosPrecalificacion.segmento!="PV"){
                    this.reglaRechazo = 'R'
                    this.listReglaRechazo=this.ofertasComerciales.reglasRechazoPersona.filter(item=>item.reglaParticipante == "Deudor").concat(this.ofertasComerciales.ofertaComercial[0].politicasOfertaDeudor.filter(item=>item.reglaDecision=="RECHAZAR"||item.reglaDecision=="SIN DECISION"))
                    this.listReglaRechazoCodeudor=this.ofertasComerciales.reglasRechazoPersona.filter(item=>item.reglaParticipante == "Codeudor").concat(this.ofertasComerciales.ofertaComercial[0].politicasOfertaCodeudor.filter(item=>item.reglaDecision=="RECHAZAR"||item.reglaDecision=="SIN DECISION"))
                    resolve('R')
                  }else{
                    this.reglaRechazo='V'
                    localStorage.setItem("codeudor", "");
                    this.datosCliente.needCoDebtor = false;
                    resolve('A');
                  }
  
                  this.setDebtorScore()
                  this.bienestarSFM=this.ofertasComerciales.ofertaComercial.filter(item=>item.bienestarMixAndMatchFlg== 1).length
                }
              }
            }, error => {
              reject(error);
            });
          }
          else if(this.tipoPrecalificacion=='tarjeta_credito'){
            this.solicitarOfertaComercialTC(datos).then(data=>{
              this.ofertasComerciales=data
              if(data.aplicaCCR=='S'){
                this.reglaRechazo = 'A'
                this.listReglaRechazo=this.ofertasComerciales.reglasRechazoPersona
                this.ofertasComerciales.ofertaComercial = data.ofertasComerciales.filter(item => item.color == 'AMARILLO')
                resolve('A')
              }else{
                this.ofertasComerciales.ofertaComercial = data.ofertasComerciales.filter(item => item.color == 'VERDE'||item.tipo=="TC_REMESA_RECONSTRUCCION"||item.tipo=="TC_PV_RECONSTRUCCION")
                if(this.ofertasComerciales.ofertaComercial.length>=1){
                  this.reglaRechazo='V'
                  resolve('A')
                }else{
                  this.reglaRechazo = 'V'
                  this.ofertasComerciales.ofertaComercial = data.ofertasComerciales //se agregan todas las ofertas rechazadas
                  resolve('A')
                }
              }
            }).catch(error=>{
              reject(error);
            })
          }
        } catch (e) {
          return e;
        }
      } catch (error) {
        reject(error);
      }
    });
  }
  setReglasRechazoOfertaMym(){
    this.reglaRechazo = 'R'
    this.banderSinofertas = true;
    this.listReglaRechazo=this.ofertasComerciales.reglasRechazoPersona.filter(item=>item.reglaParticipante == "Deudor").concat(this.ofertasComerciales.ofertaComercial[this.ofertaseleccionada].politicasOfertaDeudor.filter(item=>item.reglaDecision=="RECHAZAR"||item.reglaDecision=="SIN DECISION"))
    this.listReglaRechazoCodeudor=this.ofertasComerciales.reglasRechazoPersona.filter(item=>item.reglaParticipante == "Codeudor").concat(this.ofertasComerciales.ofertaComercial[this.ofertaseleccionada].politicasOfertaCodeudor.filter(item=>item.reglaDecision=="RECHAZAR"||item.reglaDecision=="SIN DECISION"))
  }
  validateOfertaSolicitud(){
    if(this.ofertasComerciales.ofertaComercial[this.ofertaseleccionada].polFinalProPrincipal=="RECHAZAR"){
      this.reglaRechazo = 'R'
      this.banderSinofertas = true;
      this.listReglaRechazo=this.ofertasComerciales.reglasRechazoPersona.filter(item=>item.reglaParticipante == "Deudor").concat(this.ofertasComerciales.ofertaComercial[this.ofertaseleccionada].politicasOfertaDeudor.filter(item=>item.reglaDecision=="RECHAZAR"||item.reglaDecision=="SIN DECISION"))
      this.listReglaRechazoCodeudor=this.ofertasComerciales.reglasRechazoPersona.filter(item=>item.reglaParticipante == "Codeudor").concat(this.ofertasComerciales.ofertaComercial[this.ofertaseleccionada].politicasOfertaCodeudor.filter(item=>item.reglaDecision=="RECHAZAR"||item.reglaDecision=="SIN DECISION"))
    }
  }
  setReglaRechazoTc() {
    this.reglaRechazo = 'R'
    this.listReglaRechazo=this.ofertasComerciales.reglasRechazoPersona.filter(item=>item.tipoProducto==this.ofertasComerciales.ofertaComercial[this.ofertaseleccionada].tipo).concat(this.ofertasComerciales.ofertaComercial[this.ofertaseleccionada].politicasOfertaDeudor.filter(item=>item.reglaDecision=="RECHAZAR"||item.reglaDecision=="SIN DECISION"))
  }
}
